module.exports = __webpack_public_path__ + "static/img/img-noble-logo.0fde295.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-noble-logo.svg
// module id = s4hk
// module chunks = 10